<template>
	<div class="widthFull back-color-3 ptHeader h-100">
		<loading v-if="loadingState || !progress" />
		<div
			v-if="progress == 'START'"
			class="p-4 mb-4"
		>
			<h1 class="Bold center white mt-5 pt-5">
				Inserisci i dati del <br />documento d'acquisto
			</h1>
			<div id="stepScontrino">
				<div class="card-body p-0 p-lg-5">
					<form class="text-center">
						<div class="row justify-content-center">
							<div class="col-lg-3 mb-5 mb-md-3 mb-lg-0">
								<img
									class="img-fluid mb-3"
									style="max-width: 300px !important"
									src="../../assets/images/invoice-example.png"
								/>
								<p>
									<small class="Regular mb-4 white mb-lg-1 mb-5 pb-5 mb-md-1">
										Il documento d’acquisto parlante può essere giocato soltanto
										una volta. Conserva l’originale, in caso di vincita
										immediata o a estrazione ti verrà richiesto.<br /><br />
										Documento d’acquisto parlante per gli acquisti effettuati
										presso punti vendita fisici; ricevuta d’acquisto parlante
										per gli acquisti effettuati sui siti e-commerce italiani.
										<br />
									</small>
								</p>
							</div>
							<div class="col-lg-5 text-left">
								<div class="form-row">
									<div class="col-md-12 mt-md-3 mb-3 mb-md-0">
										<div class="group">
											<input
												type="text"
												v-model="number"
												class="form-control"
												id="number"
												name="number"
												min="1"
												data-vv-as="N° documento d'acquisto"
												v-validate="{
                          required: true,
                          integer: true,
                          is_not: 0,
                          max: 10,
                        }"
												:class="{
                          'is-invalid': errors.has('number'),
                          valid: !!number,
                        }"
											/>
											<span class="highlight"></span>
											<span class="bar"></span>
											<label
												class="niceInputLabel"
												for="number"
											>
												<img
													src="../../assets/images/1.png"
													style="max-width: 25px"
													class="img img-fluid"
												/>
												N° del documento d'acquisto</label>

											<div
												v-if="errors.has('number')"
												class="invalid-feedback"
											>
												{{ errors.first("number") }}
											</div>
											<small
												id="numberHelp"
												class="form-text white"
											>
												Senza indicare gli eventuali 0 che lo precedono e senza
												eventuali trattini "-"
											</small>
										</div>
									</div>
									<div class="col-md-12 mt-md-3 mb-4 mb-md-0">
										<div class="group">
											<datepicker
												:language="it"
												v-model="date"
												:full-month-name="true"
												:format="'dd MMMM yyyy'"
												:monday-first="true"
												:disabledDates="disabledDates"
												id="date"
												name="date"
												input-class="form-control dateInput"
											></datepicker>
											<input
												type="text"
												v-show="false"
												v-model="date"
												class="form-control"
												id="date"
												name="date"
												data-vv-as="Data"
												v-validate="{ required: true }"
												:class="{
                          'is-invalid': errors.has('date'),
                          valid: !!date,
                        }"
											/>
											<span class="highlight"></span>
											<span class="bar"></span>
											<label
												class="niceInputLabel"
												for="date"
											>
												<img
													src="../../assets/images/2.png"
													style="max-width: 25px"
													class="img img-fluid"
												/>
												Data di emissione</label>
											<div
												v-if="errors.has('date')"
												class="invalid-feedback"
											>
												{{ errors.first("date") }}
											</div>
										</div>
									</div>
									<div class="col-md-12 mt-md-3 mb-4 mb-md-0">
										<div class="group">
											<vue-timepicker
												placeholder="Orario di emissione"
												v-model="time"
												class="form-control"
												data-vv-validate-on="none"
												id="time"
												name="time"
												data-vv-as="Orario"
												v-validate="{ emptyTime: true }"
												:class="{
                          'is-invalid': errors.has('time'),
                          valid: !!time.HH != '',
                        }"
											></vue-timepicker>

											<span class="highlight"></span>
											<span class="bar"></span>
											<label
												class="niceInputLabel"
												for="time"
											>
												<img
													src="../../assets/images/3.png"
													style="max-width: 25px"
													class="img img-fluid"
												/>
												Orario di emissione</label>

											<div
												v-if="errors.has('time')"
												class="invalid-feedback"
											>
												{{ errors.first("time") }}
											</div>
											<small
												id="numberHelp"
												class="form-text white Regular"
											>
												Per gli acquisti effettuati sui siti e-commerce, nel
												caso di ricevuta sprovvista dell’orario indicare 00 e 00
											</small>
										</div>
									</div>
									<div class="col-md-12 col-12 mb-4 mt-md-3">
										<div class="group priceVal pr-0 mr-0">
											<input
												type="text"
												placeholder="Euro"
												v-model="price"
												@focus="priceFocused = true"
												class="form-control text-right euroInput"
												id="price"
												name="price"
												data-vv-as="Importo Euro"
												v-validate="{
                          required: true,
                          is_not: priceCent != '00' ? '' : '0',
                          regex: /^([0-9]+)$/,
                          max: 4,
                        }"
												:class="{
                          'is-invalid': errors.has('price'),
                          valid: !!price,
                        }"
											/>
											<span class="highlight"></span>
											<span class="bar"></span>
											<label
												v-if="price && !priceCent"
												class="niceInputLabel"
											>
												<img
													src="../../assets/images/4.png"
													style="max-width: 25px"
													class="img img-fluid"
												/>
												Importo totale</label>
											<label
												v-if="!price && !priceCent"
												class="niceInputLabel"
											><img
													src="../../assets/images/4.png"
													style="max-width: 25px"
													class="img img-fluid"
												/>
												Importo totale</label>
											<label
												v-if="price && priceCent"
												class="niceInputLabel"
											><img
													src="../../assets/images/4.png"
													style="max-width: 25px"
													class="img img-fluid"
												/>
												Importo totale</label>
											<div
												v-if="errors.has('price')"
												class="invalid-feedback"
											>
												{{ errors.first("price") }}
											</div>
										</div>
										<span>,</span>
										<div class="group priceCent pl-0 ml-0">
											<input
												type="text"
												placeholder="Centesimi"
												v-model="priceCent"
												@focus="priceFocused = true"
												class="form-control text-left centInput"
												id="priceCent"
												name="priceCent"
												data-vv-as="Centesimi"
												v-validate="{
                          required: true,
                          min: 2,
                          max: 2,
                          regex: /^([0-9]+)$/,
                        }"
												:class="{
                          'is-invalid': errors.has('priceCent'),
                          valid: !!priceCent,
                        }"
											/>
											<span class="highlight"></span>
											<span class="bar"></span>
											<label
												v-if="!price && priceCent"
												class="niceInputLabel"
												for="price"
												style="margin-left: -110%"
											>
												<img
													src="../../assets/images/4.png"
													style="max-width: 25px"
													class="img img-fluid"
												/>
												Importo totale</label>
											<label
												else
												class="niceInputLabel newPriceLabel"
												for="price"
											></label>
											<div
												v-if="errors.has('priceCent') && !errors.has('price')"
												class="invalid-feedback"
											>
												{{ errors.first("priceCent") }}
											</div>
										</div>
									</div>
								</div>

								<div class="row justify-content-center">
									<div
										v-if="winner > 0"
										class="center"
									>
										<button
											type="button"
											v-on:click="play"
											class="btn btn-primary mb-4 px-5"
										>
											Gioca
										</button>
										<small class="glade">
											<b class="glade">Attenzione:</b> hai già vinto il premio
											instant win, inserisci un nuovo documento d'acquisto per
											aumentare le tue probabilità di vincere il super premio
											finale!
										</small>
									</div>
									<div
										v-else
										class="center"
									>
										<button
											type="button"
											v-on:click="play"
											class="btn btn-lg btn-primary mb-4 px-5"
										>
											Gioca
										</button>
									</div>
								</div>
							</div>
						</div>
					</form>
				</div>
			</div>
		</div>

		<div
			v-if="progress == 'SUCCESS_WIN'"
			id="SUCCESS_WIN"
			class="row justify-content-center mt-5 pt-5"
		>
			<!--Caso di vincita-->
			<div class="container-fluid mt-5 pt-5">
				<div class="row justify-content-center back-color-4">
					<div class="col-12 center mb-5">
						<h1 class="white Bold">Hai vinto una City Bike Ghiaroni!</h1>
					</div>
					<div class="col-12 center"></div>
				</div>
				<div class="row justify-content-center back-color-4">
					<div class="col-12 center mb-5">
						<h1 class="white Bold">Hai vinto un Kit vivi la tua atmosfera</h1>
					</div>
					<div class="col-12 center"></div>
				</div>
				<div class="row justify-content-center">
					<div class="col-lg-6 center mb-5">
						<p class="mt-3 Regular glade">
							<b class="white h2 Bold">Per convalidare la vincita e ricevere il premio del tuo colore
								preferito segui questi passaggi:</b>
						</p>
					</div>
					<div class="col-12"></div>
					<div class="col-6">
						<p
							v-show="!shipData"
							class="white Regular"
						>
							<img
								class="img-fluid mb-2"
								src="../../assets/images/v-step-1.png"
							/>
							Compila il form con le informazioni richieste
						</p>
						<p
							v-show="shipData"
							class="white Regular"
						>
							<img
								class="img-fluid mb-2"
								src="../../assets/images/v-step-1.png"
							/>
							I dati di spedizione sono stati correttamente salvati
						</p>
					</div>
					<div class="col-12"></div>
					<div class="col-lg-6 text-center">
						<!-- FORM  -->
						<form
							v-show="!shipData"
							@submit.prevent="doUpdateShipData"
							class="text-left pt-3"
						>
							<!--<div class="form-row mb-3">
                      <div class="col-md-12 center">
                        <h4 class="white Bold glade">
                          Inserisci i dati per la spedizione
                        </h4>
                      </div>
                    </div>-->

							<div class="form-row">
								<div class="col-md-6 mb-3">
									<div class="group">
										<input
											type="text"
											autocomplete="randomde"
											class="form-control"
											v-model="xuserx"
											id="xuserx"
											name="xuserx"
											data-vv-as="Nome"
											v-validate="{ required: true, max: 128, min: 2 }"
											:class="{
                        'is-invalid': errors.has('xuserx'),
                        valid: !!xuserx,
                      }"
										/>
										<span class="highlight"></span>
										<span class="bar"></span>
										<label
											class="niceInputLabel"
											for="xuserx"
										>Nome </label>
										<div
											v-if="errors.has('xuserx')"
											class="invalid-feedback"
										>
											{{ errors.first("xuserx") }}
										</div>
									</div>
								</div>
								<div class="col-md-6 mb-3">
									<div class="group">
										<input
											type="text"
											autocomplete="offw"
											class="form-control"
											v-model="lastnamex"
											id="lastnamex"
											name="lastnamex"
											data-vv-as="Cognome"
											v-validate="{ required: true, max: 128, min: 2 }"
											:class="{
                        'is-invalid': errors.has('lastnamex'),
                        valid: !!lastnamex,
                      }"
										/>
										<span class="highlight"></span>
										<span class="bar"></span>
										<label
											class="niceInputLabel"
											for="lastnamex"
										>Cognome
										</label>

										<div
											v-if="errors.has('lastnamex')"
											class="invalid-feedback"
										>
											{{ errors.first("lastnamex") }}
										</div>
									</div>
								</div>
							</div>

							<div class="form-row">
								<div class="col-md-6 mb-3">
									<div class="group">
										<input
											type="text"
											autocomplete="randome"
											class="form-control"
											v-model="phone"
											id="phone"
											name="phone"
											data-vv-as="Telefono"
											v-validate="{ required: true, max: 11, min: 8 }"
											:class="{
                        'is-invalid': errors.has('phone'),
                        valid: !!phone,
                      }"
										/>
										<span class="highlight"></span>
										<span class="bar"></span>
										<label
											class="niceInputLabel"
											for="phone"
										>Telefono </label>
										<div
											v-if="errors.has('phone')"
											class="invalid-feedback"
										>
											{{ errors.first("phone") }}
										</div>
									</div>
								</div>
								<div class="col-md-6 mb-3">
									<div class="group">
										<input
											type="text"
											autocomplete="randomr"
											class="form-control"
											v-model="address"
											id="address"
											name="address"
											data-vv-as="Indirizzo"
											v-validate="{ required: true, max: 128, min: 5 }"
											:class="{
                        'is-invalid': errors.has('address'),
                        valid: !!address,
                      }"
										/>
										<span class="highlight"></span>
										<span class="bar"></span>
										<label
											class="niceInputLabel"
											for="address"
										>Indirizzo
										</label>
										<div
											v-if="errors.has('address')"
											class="invalid-feedback"
										>
											{{ errors.first("address") }}
										</div>
									</div>
								</div>
							</div>

							<div class="form-row">
								<div class="col-md-6 mb-3">
									<div class="group">
										<input
											type="text"
											autocomplete="randomt"
											class="form-control"
											v-model="civic"
											id="civic"
											name="civic"
											data-vv-as="Civico"
											v-validate="{ required: true, max: 15 }"
											:class="{
                        'is-invalid': errors.has('civic'),
                        valid: !!civic,
                      }"
										/>
										<span class="highlight"></span>
										<span class="bar"></span>
										<label
											class="niceInputLabel"
											for="civic"
										>N° civico</label>
										<div
											v-if="errors.has('civic')"
											class="invalid-feedback"
										>
											{{ errors.first("civic") }}
										</div>
									</div>
								</div>
								<div class="col-md-6 mb-3">
									<div class="group">
										<select
											v-model="province"
											autocomplete="randomy"
											id="province"
											name="province"
											class="form-control"
											data-vv-as="Provincia"
											v-validate="{ required: true }"
											:class="{
                        'is-invalid': errors.has('province'),
                        valid: !!province,
                      }"
										>
											<option
												v-if="!shipData.province"
												disabled
												value=""
												selected="selected"
											></option>
											<option
												v-else
												:value="shipData.province"
												selected="selected"
											>
												{{ shipData.province }}
											</option>
											<option
												v-for="province in provinces"
												:key="province.sigla"
												v-bind:value="province.sigla"
												:selected="province.sigla == shipData.province"
											>
												{{ province.sigla }} - {{ province.provincia }}
											</option>
										</select>
										<span class="highlight"></span>
										<span class="bar"></span>
										<label
											class="niceInputLabel"
											for="province"
										>Provincia
										</label>
										<div v-if="provincesState">
											<font-awesome-icon
												class="loadSpinner"
												id="loadProvince"
												icon="spinner"
												size="1x"
												pulse
											/>
										</div>
										<div
											v-if="errors.has('province')"
											class="invalid-feedback"
										>
											{{ errors.first("province") }}
										</div>
									</div>
								</div>
								<div class="col-md-6 mb-3">
									<div class="group">
										<select
											class="form-control"
											autocomplete="randomu"
											v-model="city"
											v-on:click="checkProvince"
											id="city"
											name="city"
											data-vv-as="Comune"
											v-validate="{ required: true }"
											:disabled="citiesState"
											:class="{
                        'is-invalid': errors.has('city'),
                        valid: !!city,
                      }"
										>
											<option
												v-if="!shipData.city"
												disabled
												value=""
												selected="selected"
											></option>
											<option
												else
												:value="{ city: shipData.city }"
												selected="selected"
											>
												{{ shipData.city }}
											</option>
											<option
												v-for="city in cities"
												:key="city.comune"
												v-bind:value="{
                          cityistat: city.istat,
                          city: city.comune,
                        }"
												:selected="city.comune == shipData.city"
											>
												{{ city.comune }}
											</option>
										</select>

										<span class="highlight"></span>
										<span class="bar"></span>
										<label
											class="niceInputLabel"
											for="city"
										>Comune
											<span
												v-if="cityError"
												class="formError"
											>Prima scegli Provincia</span></label>
										<div v-if="citiesState">
											<font-awesome-icon
												class="loadSpinner"
												id="loadCity"
												icon="spinner"
												size="1x"
												pulse
											/>
										</div>
										<div
											v-if="errors.has('city')"
											class="invalid-feedback"
										>
											{{ errors.first("city") }}
										</div>
									</div>
								</div>
								<div class="col-md-6 mb-3">
									<div class="group">
										<select
											class="form-control"
											autocomplete="randomi"
											v-model="zip"
											v-on:click="checkZip"
											id="zip"
											name="zip"
											data-vv-as="Cap"
											v-validate="{ required: true }"
											:disabled="zipsState"
											:class="{
                        'is-invalid': errors.has('zip'),
                        valid: !!zip,
                      }"
										>
											<option
												v-if="!shipData.zip"
												value=""
												disabled
												:selected="true"
											></option>
											<option
												v-for="zip in zips"
												:key="zip.cap"
												v-bind:value="zip.cap"
												:selected="zip.cap == shipData.zip"
											>
												{{ zip.cap }}
											</option>
										</select>
										<span class="highlight"></span>
										<span class="bar"></span>
										<label
											class="niceInputLabel"
											for="zip"
										>Cap
											<span
												v-if="zipError"
												class="formError"
											>Prima scegli Località</span>
										</label>
										<div v-if="zipsState">
											<font-awesome-icon
												class="loadSpinner"
												id="loadZips"
												icon="spinner"
												size="1x"
												pulse
											/>
										</div>
										<div
											v-if="errors.has('zip')"
											class="invalid-feedback"
										>
											{{ errors.first("zip") }}
										</div>
									</div>
								</div>

								<div class="col-md-12 mb-1">
									<div class="group">
										<input
											type="text"
											autocomplete="randomo"
											class="form-control"
											v-model="near"
											id="near"
											name="near"
											data-vv-as="Presso"
											v-validate="{ max: 128, min: 2 }"
											:class="{
                        'is-invalid': errors.has('near'),
                        valid: !!near,
                      }"
										/>
										<span class="highlight"></span>
										<span class="bar"></span>
										<label
											class="niceInputLabel"
											for="lastname"
										>Presso / Nome sul citofono
										</label>

										<div
											v-if="errors.has('near')"
											class="invalid-feedback"
										>
											{{ errors.first("near") }}
										</div>
									</div>
								</div>
							</div>

							<div class="form-row mb-5">
								<div class="col-md-12 center mb-5">
									<button
										v-if="!uploadFrontPercentage && !uploadRearPercentage"
										class="btn btn-primary mt-3 px-5"
										type="submit"
									>
										Salva le informazioni
									</button>

									<img
										v-else
										class="replaceButton"
										src="../../assets/images/load.gif"
									/>
								</div>
							</div>
						</form>
						<div class="row">
							<div class="col-12 text-left">
								<p class="Regular white">
									<img
										class="img-fluid"
										src="../../assets/images/v-step-2.png"
									/>
									Segue queste indicazioni:
								</p>
								<p class="Regular white">
									Invia l’originale dello scontrino parlante utilizzato per la
									giocata unitamente ai tuoi dati e alla fotocopia del documento
									d’identità in corso di validità tramite raccomandata entro 7
									giorni dalla vincita (farà fede la data del timbro postale)
									a:<br />
									<b>Concorso “Vivi la tua atmosfera Glade®” - Secondo Periodo -
										c/o Proxima S.p.A. - Via Malavolti, 59/63 - 41122 Modena
										(MO)</b><br />
									Saranno prese in considerazione tutte le raccomandate
									pervenute entro il 20 giugno 2022.<br /><br />
									Ricordati che parteciperai all’estrazione del premio finale.
									<br /><br />
									<a class="Medium nounderline white">Si ricorda che se i dati che hai indicato in questo form
										non dovessero corrispondere a quelli forniti nella
										documentazione cartacea inviata, si terrà conto di questi
										ultimi per la spedizione del premio (non verrà preso in
										considerazione un eventuale indirizzo diverso indicato sul
										documento di identità).<br /><br />
										Ti consigliamo di fotocopiare la documentazione inviata e di
										conservarne copia.</a>
								</p>
							</div>
						</div>
						<div class="row justify-content-center mb-5 pb-5">
							<a
								class="text-center mx-auto mt-4 mb-5 white Regular h4"
								style="text-decoration: underline"
								v-on:click="reload"
							>Inserisci un altro documento d'acquisto</a>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div
			v-else-if="progress == 'ALREADY_WIN'"
			class="container h-100 pb-5 mt-md-5 pt-md-5"
			id="ALREADY_WIN"
		>
			<!--Caso in cui l-utente ha gia vinto-->
			<div class="row justify-content-center pt-md-5">
				<div class="col-12 center page-header Bold mb-5 pb-4">
					<h1
						class="white Bold"
						id="titleEsitoScIns"
					>
						Documento d'acquisto registrato
					</h1>
				</div>
			</div>
			<div class="row">
				<div class="col-lg-6 text-center my-auto"></div>
				<div class="col-lg-4 my-auto">
					<h5 class="d-none d-lg-block Bold white">
						Hai una possibilità in piú di vincere un
						<b class="">1 FIAT 500 ELETTRICA.</b>
					</h5>
				</div>
			</div>
			<div class="row justify-content-center">
				<a
					class="text-center mx-auto mt-4 mb-5 white Regular h4"
					style="text-decoration: underline"
					v-on:click="reload"
				>Inserisci un altro documento d'acquisto</a>
			</div>
		</div>

		<div
			v-else-if="progress == 'SUCCESS_LOSE'"
			id="SUCCESS_LOSE"
			class="container"
		>
			<div class="row justify-content-center pt-5 mb-5 pb-4">
				<div class="col-12 center white page-header Bold pt-5 mt-4">
					<h1
						class="Bold glade"
						id="titleEsitoPerso"
					>
						Peccato, non hai vinto
					</h1>
				</div>
			</div>
			<div class="row">
				<div class="col-lg-6 text-center my-auto"></div>
				<div class="col-lg-4 my-auto">
					<div class="h4">
						<b class="Bold white">Ma ricordati che partecipi all'estrazione finale! Potresti
							vincere 1 FIAT 500 ELETTRICA.
						</b>
					</div>
				</div>
			</div>
			<div class="row justify-content-center mb-5 pb-5">
				<a
					class="text-center mx-auto mt-4 mb-5 white Regular h4"
					style="text-decoration: underline"
					v-on:click="reload"
				>Inserisci un altro documento d'acquisto</a>
			</div>
		</div>
	</div>
</template>
<script>
	import { mapState, mapGetters } from 'vuex';
	import axios from 'axios';
	import { USER_REQUEST, USER_SET_DEFAULT_SHIP_DATA } from 'actions/user';
	import Datepicker from 'vuejs-datepicker';
	import { it } from 'vuejs-datepicker/dist/locale';
	import VueTimepicker from 'vue2-timepicker';
	// import VideoBackground from 'vue-responsive-video-background-player';

	import { FormWizard, TabContent } from 'vue-form-wizard';
	import 'vue-form-wizard/dist/vue-form-wizard.min.css';

	import { checkUniqueMixin } from '../../mixins/checkUniqueMixin';
	import { toDateMixin } from '../../mixins/toDateMixin';
	import { sharedEnvMixin } from '../../mixins/sharedEnvMixin';
	import { innerWidthMixin } from '../../mixins/innerWidthMixin';
	import { playFunctionMixin } from '../../mixins/playFunctionMixin';
	import { locationMixin } from '../../mixins/locationMixin';

	const moment = require('moment');

	export default {
		name: 'play',
		components: {
			Datepicker,
			VueTimepicker,
			// VideoBackground,
			FormWizard,
			TabContent,
		},

		mixins: [
			checkUniqueMixin,
			toDateMixin,
			sharedEnvMixin,
			innerWidthMixin,
			playFunctionMixin,
			locationMixin,
		],
		data() {
			return {
				prod: '',
				videoLoaded: false,
				videoOpacity: 1,
				showDateInfoVar: false,
				it: it,
				timeVal: '',
				prod1: '',
				prod2: '',
				stepPopUp: true,
				priceFocused: false,
				colorType: '',
				product: '',
				advisor: false,
				productIndex: 1,
				showProdError: false,
				quantity: '',
				disabledDates: {
					to: '',
					from: '',
				},

				pdvs: [],
				pdvsState: false,
				pdvState: false,
				pdvsError: false,
				pdv_prov: '',
				prodSel1: false,
				prodSel2: false,
				pdv: '',
				pdv_city: '',
				pdv_cities: [],
				items: {},
				provincesState: true,
				cities: [],
				citiesState: false,
				zips: [],
				zipsState: false,
				allInvoiceInfo: false,
				question: '',
				canScroll: true,
				scrollFinished: false,
				stepSize: 'md',
				rebate: '',
				totPrice: '',
				priceError: false,
				timeC: false,
				countdown: 0,
				datenow: '',
				showInfo: false,
				token: '',
				id_image: '',
				zip: '',
				city: '',
				province: '',
				endedVideo: true,
				taglia: '',
				taglie: [],
			};
		},
		methods: {
			showSuccessUpdateSHIP() {
				// Use sweetalret2
				this.$swal({
					type: 'success',
					title: 'I dati per la spedizione sono stati correttamente aggiornati',
					timer: 4500,
				});
			},
			ended: function () {
				this.endedVideo = true;
			},
			videoReady: function () {
				this.videoLoaded = true;
			},
			async recaptcha() {
				var _vue = this;
				const recaptcha = _vue.$recaptchaInstance;

				// (optional) Wait until recaptcha has been loaded.
				await _vue.$recaptchaLoaded();

				// Execute reCAPTCHA with action "login".
				this.token = await _vue.$recaptcha('login');

				// Do stuff with the received token.
			},
			stepIndex(from, to) {
				if (this.scrActiv) {
					//this.$scrollTo('.main', 700, { offset: -170 });
					if (to == 0) {
						this.$route.hash != '#step1'
							? this.$router.push({ hash: '#step1' })
							: '';
					}
					if (to == 1) {
						this.$route.hash != '#step2'
							? this.$router.push({ hash: '#step2' })
							: '';
					}
					if (to == 2) {
						this.$route.hash != '#step3'
							? this.$router.push({ hash: '#step3' })
							: '';
					}
				}

				if (to == 1) {
					this.showInfo = true;
				} else {
					this.showInfo = false;
				}
				this.$track('STEP', from + ' => ' + to);
			},
			checkProducts: function (param) {
				var products = this.products;
				var count = 0;
				if (param) {
					this.showProdError = false;
				} else {
					for (var i in products) {
						var prod = products[i].product;
						if (products[i].quantity) {
							if (prod.includes('30')) {
								count = count + 1 * parseInt(products[i].quantity);
							} else {
								count = count + 3 * parseInt(products[i].quantity);
							}
						}
					}
					if (count >= 3) {
						this.showProdError = false;
					} else {
						this.showProdError = true;
					}
				}
			},
			showViever() {
				var el = this.$refs.inv;
				const viewer = el.$viewer;
				viewer.show();
			},
			timeReactive() {
				if (this.timeStore > moment(process.env.VUE_APP_FINISH)) {
					window.location.replace('/');
				}
			},
			calcTotPrice: function () {
				var prod = this.products;
				var count = 0;
				for (var x in prod) {
					if (prod[x].price && prod[x].quantity) {
						count =
							count +
							parseFloat(prod[x].price).toFixed(2) * parseInt(prod[x].quantity);
					}
				}
				if (isNaN(count)) {
					count = 0.0;
				}

				if (count > 0) {
					this.priceError = false;
				} else {
					this.priceError = true;
				}

				this.totPrice = parseFloat(count).toFixed(2);
			},

			sessionFail: function () {
				this.$swal({
					type: 'error',
					title: '',
					html: '<h4 class="smallText">La tua sessione è scaduta. Effettua nuovamente l`operazione.</h4>',
					confirmButtonText: 'CHIUDI',
					onClose: () => {
						this.$router.push('/');
						setTimeout(function () {
							window.location.reload();
						}, 500);
					},
				});
			},
			reload: function () {
				window.location.reload();
			},
			resetStatus: function () {
				//window.location.reload();
				this.progress = 'START';
				var _vue = this;
				this.invoiceFrontBucket = '';
				this.invoiceRearBucket = '';
				this.date = '';
				this.time.HH = '';
				this.time.mm = '';
				this.price = '';
				this.priceCent = '';
				this.number = '';
				this.documentType = '';
				this.xuserx = '';
				this.lastnamex = '';
				this.products = {};
				this.documentType = '';
				this.ocrData = '';
				this.award = '';
				this.invoiceStatus = '';
				this.pratica = '';
				this.xuserx = '';
				this.lastnamex = '';
				this.address = '';
				this.civic = '';
				this.province = '';
				this.city.city = '';
				this.zip = '';
				this.phone = '';
				this.near = '';
			},

			showErrorOCR(text) {
				var html =
					'<p class="smallText text-left">Nell`immagine eventualmente caricata:</p><ul>';

				var x = 0;
				var z = 0;
				for (var i in text) {
					if (text[i].status == 'KO') {
						if (text[i].description) {
							html +=
								'<li class="smallText text-left">' +
								text[i].description +
								'</li>';
						}

						x++;
					}
					//if ( text[i].error == 'price_less' ){
					//  z = 1
					//}
				}
				html += '</ul>';

				// TO MANY ERROR = IS NOT INVOICE
				if (x >= 4) {
					html =
						'<p class="smallText text-left">Purtroppo l`immagine caricata non sembra essere quella di un scontrino.</p>';
					html +=
						'<ul><li class="smallText text-left">I dati sullo scontrino devono essere ben visibili.</li>';
					html +=
						'<li class=" smallText text-left mt-2">Se lo scontrino è troppo lungo, piegalo a fisarmonica per mostrare solo i dati necessari</li> ';
					html +=
						'<li class=" smallText text-left mt-2">La foto caricata deve avere un peso compreso fra 12KB e 10MB</li></ul> ';
					html +=
						'<p class="smallText text-left mt-3">Prova a rifare la foto e ricarica lo scontrino</p> ';
					z = 4;
				} else if (x <= 3) {
					html += '<p class="smallText text-left">Attenzione!</p>';
					if (x == 1 && text.date.error == 'not_play_period') {
						// IF ONLY DATE OUT OF PERIOD
						// html += '<ul><li class="smallText text-left">Sono passati piú di 5 giorni compreso oggi dalla data di acquisto riportata sul documento di vendita.</li></ul>'
					} else {
						// IF MANY ERRORS
						html +=
							'<ul><li class="smallText text-left">I dati sullo scontrino devono essere ben visibili.</li>';
						html +=
							'<li class=" smallText text-left mt-2">Se lo scontrino è troppo lungo piegalo a fisarmonica per mostrare solo i dati necessari</li>';
						html +=
							'<li class=" smallText text-left mt-2">La foto caricata deve avere un peso compreso fra 12KB e 10MB</li></ul> ';
						html +=
							'<p class="smallText text-left mt-3">Prova a rifare la foto e ricarica lo scontrino</p> ';
					}
				}
				this.$swal({
					type: 'error',
					title: '<strong class="">Ops!</strong>',
					html: html,
					//confirmButtonText: "Esempio scontrino",
					confirmButtonColor: '#c95c1c',
					//showCancelButton: true,
					cancelButtonText: 'Chiudi',
					cancelButtonColor: 'black',
				}).then((okay) => {});
			},
			validateFirstTab: function () {
				var _vue = this;

				return this.$validator.validateAll('form-1');
			},
			validateSecondTab: function () {
				return this.$validator.validateAll('form-3');
			},
			validateThirdTab: function () {
				if (this.invoiceFront) {
					return this.$validator.validateAll('form-4');
				} else {
					return false;
				}
				//return true;
			},
			validate4Tab: function () {
				//if ( this.totPrice > 0 ){
				return this.$validator.validateAll('form-2');
				//  }else{
				//    this.priceError = true
				//    return false
				//  }
			},
			onComplate: function () {
				this.play();
			},

			showDateInfo() {
				if (this.showDateInfoVar) {
					this.showDateInfoVar = false;
				} else {
					this.showDateInfoVar = true;
				}
			},
			showError(text) {
				this.$swal({
					type: 'error',
					title: '<strong class="modalText danger">' + text + '</strong>',
					html: '',
					confirmButtonText: 'CHIUDI',
				});
			},
			showDublicateImage(img) {
				this.$swal({
					type: 'error',
					title: 'Ops!',
					html:
						'<p class="center smallText">Lo scontrino:</p> <p class="center smallText">' +
						img +
						'</p><p class="center smallText"> risulta già caricata</p>',
					confirmButtonText: 'CHIUDI',
				});
			},

			addProduct() {
				this.productIndex = this.productIndex + 1;
				this.products.push({
					index: 'product' + this.productIndex,
					indexCount: 'quantity' + this.productIndex,
					product: '',
					quantity: '',
					price: '',
				});
			},
			removeProduct(elem) {
				var _vue = this;
				var index = this.products.indexOf(elem);
				this.products.splice(elem, 1);
				_vue.calcTotPrice();
			},

			infoPopUp() {
				this.$swal({
					//input: 'text',
					confirmButtonText: 'Carica FRONTE &rarr;',
					imageUrl: require('../../assets/images/invoice-example.png'),
					imageClass: 'minImg',
					focusCancel: false,
					focusConfirm: true,
					cancelButtonText: 'Annulla',
					showCancelButton: true,
					title: '',
					html:
						'<p class="smallText text-left"><ul  class="smallText text-left"><li class="smallText">I dati sullo scontrino devono essere ben visibili. </li>' +
						'<li class="smallText">Se lo scontrino è troppo lungo piegalo a fisarmonica per mostrare solo i dati necessari</li>' +
						'<li class=" smallText text-left mt-2">La foto caricata deve avere un peso compreso fra 12KB e 10MB</li></ul></p>',
				}).then((result) => {
					if (result.value) {
						this.$refs.fileInput1.click();
					}
				});
			},

			changeSwalImage: function () {
				alert('sdfgasd');
			},
			UploadError() {
				this.$swal({
					type: 'error',
					title:
						'<strong class="modalText danger">Errore caricamento immagine</strong>',
					html: '',
					confirmButtonText: 'CHIUDI',
					confirmButtonColor: '#15267',
				});
			},
			UploadError2(type) {
				if (type == 'size') {
					var html =
						'<p class="smallText text-left" >L`immagine supera peso massimo di 10 Mega</p>';
				} else if (type == 'size2') {
					var html =
						'<p class="smallText text-left" >La foto caricata è in bassa risoluzione grafica.</p><p class="smallText text-left" >Carica una nuova foto ad alta risoluzione</p>';
				} else {
					var html =
						'<p class="smallText text-left" >Sono valide le immagine in formato .pdf, .jpg, .jpeg o .png</p>';
				}

				this.$swal({
					type: 'error',
					title: '<strong class="smallText danger">!Attenzione</strong>',
					html: html,
					confirmButtonText: 'CHIUDI',
					confirmButtonColor: '#15267',
				});
			},

			openListProducts() {
				// Use sweetalret2
				this.$swal({
					type: '',
					title: '<strong class="modalText h2">prodotti in promozione</strong>',
					html:
						'<br/><br/><h5 class="modalText ">- Birra Messina 33cl</h5>' +
						'<h5 class="modalText even ">- Birra Messina 3x33cl</h5>' +
						'<h5 class="modalText ">- Birra Messina Cristalli di Sale 50cl</h5><br/><br/>',
					width: 600,
					confirmButtonText: 'chiudi',
				});
			},

			checkDefaultShipData() {
				if (this.shipData.name) {
					this.name = this.shipData.name;
					this.lastname = this.shipData.lastname;
					this.address = this.shipData.address;
					this.civic = this.shipData.civic;
					this.near = this.shipData.near;
					this.phone = this.shipData.phone;
					this.province = this.shipData.province;
					this.city = {};
					this.city.city = this.shipData.city;
					this.city.istat = 'toset';

					this.zip = this.shipData.zip;
					//this.zips = [
					//	cap => this.shipData.zip
					//]
				}
			},
			scrollToTop: function () {
				var _vue = this;
				setTimeout(function () {
					//_vue.$scrollTo('.main', 700, { offset: -120 });
				}, 100);
			},
			visibilityHow(isVisible, entry) {
				if (isVisible && this.scrollFinished) {
					this.$route.hash != '#come_partecipare'
						? this.$router.push({ hash: '#come_partecipare' })
						: '';
				}
			},
			visibilityPlay(isVisible, entry) {
				if (isVisible && this.scrollFinished) {
					this.$route.hash != '#partecipa'
						? this.$router.push({ hash: '#partecipa' })
						: '';
				}
			},
			visibilityLogin(isVisible, entry) {
				if (isVisible && this.scrollFinished) {
					this.$route.hash != '#login'
						? this.$router.push({ hash: '#login' })
						: '';
				}
			},

			setProfileData: function () {
				if (process.env.VUE_APP_HAS_LOGIN == 'ON') {
					this.email = this.profile.email;
					this.userToken = this.profile.id;
				} else {
					this.email = this.email;
					this.userToken = makeid(10);
				}
			},
		},
		watch: {
			prod: {
				handler(val) {
					if (val) {
						this.prodSel1 = true;
						this.advisor = false;
					} else {
						this.prodSel1 = false;
						this.advisor = false;
					}
				},
			},
			prod2: {
				handler(val) {
					if (val) {
						this.prodSel2 = true;
						this.advisor = false;
					} else {
						this.prodSel2 = false;
						this.advisor = false;
					}
				},
			},
			date: function (val) {},
			time: function (val) {},
			podium1Selected: function (val) {
				if (val) {
					this.podium2Selected = false;
				}
			},
			podium2Selected: function (val) {
				if (val) {
					this.podium1Selected = false;
				}
			},
			xuserx: function (val) {
				if (val) {
					this.xuserx = val.replace(/\d+/g, '');
					this.xuserx = this.xuserx.replace(
						/[`~!@#$£%^&*()_|+\-=?;:",.<>\{\}\[\]\\\/]/gi,
						''
					);
					this.xuserx =
						this.xuserx.charAt(0).toUpperCase() + this.xuserx.slice(1);
				}
			},
			lastnamex: function (val) {
				if (val) {
					this.lastnamex = val.replace(/\d+/g, '');
					this.lastnamex = this.lastnamex.replace(
						/[`~!@#$£%^&*()_|+\-=?;:",.<>\{\}\[\]\\\/]/gi,
						''
					);
					this.lastnamex =
						this.lastnamex.charAt(0).toUpperCase() + this.lastnamex.slice(1);
				}
			},
			pdv_city: function (val) {
				if (val) {
					this.pdv_city = val.replace(/\d+/g, '');
					this.pdv_city = this.pdv_city.replace(
						/[`~!@#$£%^&*()_|+\-=?;:",.<>\{\}\[\]\\\/]/gi,
						''
					);
					this.pdv_city =
						this.pdv_city.charAt(0).toUpperCase() + this.pdv_city.slice(1);
				}
			},
			number: function (val) {
				if (val) {
					this.number = val.replace(/\D+/g, '');
				}
				if (val < 0) {
					this.number = val.replace(val, 0);
				}
			},
			phone: function (val) {
				if (val) {
					this.phone = val.replace(/\D+/g, '');
				}
			},
			// IF CHANGE PROVINCE -> LOAD CITIES
			province: function (newProvince) {
				this.zips = [];
				this.cities = [];
				this.zip = '';
				this.city = '';
				this.cityError = false;
				this.zipError = false;

				if (newProvince) {
					this.citiesState = true;
					axios({
						url: process.env.VUE_APP_ROOT_API + 'api/getComuni',
						method: 'POST',
						data: {
							sigla: newProvince,
						},
						headers: {
							Authorization: 'Bearer ' + process.env.VUE_APP_KITTY,
							'Content-type': 'application/json',
						},
					})
						.then((resp) => {
							this.cities = resp.data.cities;
							this.citiesState = false;
						})
						.catch((resp) => {
							this.cities = [];
							this.citiesState = false;
						});
				}
			},
			// IF CHANGE PROVINCE -> LOAD CITIES
			pdv_prov: function (newProvince) {
				this.pdv = [];
				this.pdvsState = false;
				this.pdv = '';
				this.pdv_city = '';
				this.pdvsError = false;
				this.pdvError = false;
			},
			city: function (newCity) {
				this.zipError = false;
				this.zips = [];
				this.zip = '';

				if (newCity.cityistat) {
					this.zipsState = true;
					axios({
						url: process.env.VUE_APP_ROOT_API + 'api/getCap',
						method: 'POST',
						data: {
							istat: newCity.cityistat,
						},
						headers: {
							Authorization: 'Bearer ' + process.env.VUE_APP_KITTY,
							'Content-type': 'application/json',
						},
					})
						.then((resp) => {
							this.zips = resp.data.cap;
							this.zipsState = false;
						})
						.catch((resp) => {
							this.zips = [];
							this.zipsState = false;
						});
				}
			},
			vw: function () {
				if (this.vw > 1200) {
					this.stepSize = 'md';
				} else if (this.vw > 600) {
					this.stepSize = 'sm';
				} else {
					this.stepSize = 'xs';
				}
			},
			getProfile: function () {
				this.setProfileData();
			},
		},
		updated: function () {},
		created() {
			var now = this.timeStore;
			var then = moment(process.env.VUE_APP_OCR_END);
			var dif = then.diff(now, 'days', true);
			this.setProfileData();
			//moment.utc(moment(now,"DD/MM/YYYY HH:mm:ss").diff(moment(then,"DD/MM/YYYY HH:mm:ss"))).format("HH:mm:ss")
			this.countdown = parseInt(dif * 14.28);
		},
		async mounted() {
			if (hasLogin) {
				await this.retrivePlays();
			} else {
				_vue.progress = 'START';
			}
			this.setProfileData();
			//await this.recaptcha();
			this.populateProvincesPdv();
			var now = this.timeStore;
			var then = moment(process.env.VUE_APP_OCR_END);
			var dif = then.diff(now, 'hours', true);

			//moment.utc(moment(now,"DD/MM/YYYY HH:mm:ss").diff(moment(then,"DD/MM/YYYY HH:mm:ss"))).format("HH:mm:ss")
			this.countdown = parseInt(dif);

			if (this.canScroll) {
				//this.$scrollTo('.main', 300, { offset: -85 });

				this.canScroll = false;
			}
			if (
				process.env.VUE_APP_INSTANT_WIN == 'ON' &&
				process.env.VUE_APP_MORE_WIN == 'OFF'
			) {
				var xkey = localStorage.getItem(
					'$%r332d2we24#@$234' + process.env.VUE_APP_ICODE + '1SDe452@#$%'
				);
				if (xkey == '$&@(*(@Jde20)($40E#@_(_Q#($_@(*_EIS') {
					var xkeyID = localStorage.getItem(
						'$%r332d324#@$234' + process.env.VUE_APP_ICODE + '245DSDe452@#$%'
					);
					var er = this.$decryptWORMY(xkeyID);
					this.invoiceStatus = '600';
					this.justWinCheck = 'Vincita pregressa con email => <br/>' + er;
				}
			}

			if (process.env.VUE_APP_HAS_LOGIN == 'ON') {
				this.$track('Getprofile', this.getProfile);
				this.lastnamex = this.getProfile.cognome;
				this.xuserx = this.getProfile.nome;

				if (this.isAuthenticated) {
					this.$watch(
						() => {},
						(val) => {}
					);
				}
			}

			var _vue = this;

			setInterval(_vue.timeReactive, 5000);

			setTimeout(function () {
				_vue.populateProvinces(),
					(_vue.disabledDates = {
						to: _vue.calcToDate(), // Disable all dates up to specific date
						from: _vue.calcFromDate(), // Disable all dates after specific date
					});

				_vue.scrollFinished = true;
			}, 1500);
		},
		computed: {
			...mapGetters([
				'getProfile',
				'xkey',
				'isAuthenticated',
				'isProfileLoaded',
				'acceptCookies',
				'checkAge',
			]),
			...mapState({
				profile: (state) => state.user.profile,
			}),
			timeStore() {
				return this.$timestore.now;
			},
		},
	};
</script>

